
import { axios } from '@/utils/request'

/**
 * login func
 * parameter: {
 *     username: '',
 *     password: '',
 * }
 * @param parameter
 * @returns {*}
 */
export function login (parameter) {
  return axios({
    url: '/login',
    method: 'post',
    data: parameter
  })
}

/**
 * 滑块验证通过后的登录，captchaId 为一次性验证凭证
 * parameter: {
 *     account: '',
 *     passwd: '',
 *     appid: '',
 *     captchaId: '',
 * }
 * @param parameter
 * @returns {*}
 */
export function sliderLogin (parameter) {
  return axios({
    url: '/slider/login',
    method: 'post',
    data: parameter
  })
}

export function getInfo () {
  return axios({
    url: '/user/info/load',
    method: 'post',
    data: {}
  })
}

export function logout () {
  return axios({
    url: '/auth/logout',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function reg (parameter) {
  return axios({
    url: '/user/reg',
    method: 'post',
    data: parameter
  })
}
